import { render } from "./unauthorised.vue?vue&type=template&id=5acfa1a3&scoped=true"
import script from "./unauthorised.vue?vue&type=script&lang=js"
export * from "./unauthorised.vue?vue&type=script&lang=js"

import "./unauthorised.vue?vue&type=style&index=0&id=5acfa1a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acfa1a3"]])

export default __exports__